import {
  CheckoutLinkResponseType,
  PostCheckoutLinkRequestType,
  PostCheckoutLinkResponseType,
} from 'QuoteApp/services/endpoints/PostCheckoutLink';
import { useLazyQuoteApi } from 'Shared/services/Api';
import { useCallback, useState } from 'react';

export const useCheckoutLink = (appId: string) => {
  const [{ loading: sendCheckoutLinkInProgress }, _postCheckoutLink] =
    useLazyQuoteApi<PostCheckoutLinkResponseType>({
      method: 'POST',
      url: `/insurance_applications/${appId}/checkout_link`,
    });

  const [checkoutLink, setCheckoutLink] = useState<
    CheckoutLinkResponseType | undefined
  >();

  const [{ loading: fetchCheckoutLinkLoading }, _getCheckoutLink, token] =
    useLazyQuoteApi<CheckoutLinkResponseType>({
      method: 'GET',
      url: `/insurance_applications/${appId}/checkout_link`,
    });

  const sendCheckoutLink = useCallback(
    async (params: PostCheckoutLinkRequestType) => {
      const response = await _postCheckoutLink({
        data: params,
      });

      return response.data;
    },
    [_postCheckoutLink]
  );

  const fetchCheckoutLink = useCallback(async () => {
    if (!token) return undefined;
    try {
      const response = await _getCheckoutLink();
      setCheckoutLink(response.data);
      return response.data;
    } catch {
      return undefined;
    }
  }, [_getCheckoutLink, token]);

  return {
    sendCheckoutLinkInProgress,
    sendCheckoutLink,
    checkoutLink,
    fetchCheckoutLinkLoading,
    fetchCheckoutLink,
  };
};
